module.exports = __webpack_public_path__ + "img/price-icon-neo-qled-8k.10412ddd.png";